import type { ReactNode } from "react";

import { Logo } from "./Logo";
import { MAIN_CONTENT_ID, SkipLink } from "./SkipLink";

/** Centered card layout for sign-in, sign-up and e-mail link pages. */
export function AuthLayout({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="flex min-h-full flex-col items-center justify-center px-4 py-12">
      <SkipLink />
      <header className="mb-8">
        <Logo />
      </header>
      <main
        id={MAIN_CONTENT_ID}
        tabIndex={-1}
        className="w-full max-w-sm rounded-xl border border-border bg-surface p-6 shadow-sm sm:p-8"
      >
        <h1 className="text-xl font-semibold tracking-tight text-fg">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-fg-muted">{subtitle}</p>}
        <div className="mt-6">{children}</div>
      </main>
    </div>
  );
}
